<button
    class="option-button"
    (click)="optionClick.emit(variantNo || '')"
    [attr.aria-label]="name"
    [ngClass]="{ 'option-button-active': isSelected }"
>
    <app-svg-icon *ngIf="isSelected" iconName="tick" class="checked-option"></app-svg-icon>
    <div class="option-item">
        <div class="image-wrapper">
            <app-image [image]="image" [width]="187" [height]="136">
                <span class="kk-visuallyhidden">{{ name }}</span>
            </app-image>

            <div class="information">
                <span class="name display-label">{{ name }}</span>
                <div class="price display-6">{{ displayPrice }}</div>
            </div>
        </div>
    </div>
</button>
